import React from 'react';
import { ResponsiveImage } from './ResponsiveImage';
import { ArrowRight } from 'lucide-react';
import { solutions } from '../data/mock';

const Solutions = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl lg:text-4xl font-serif text-gray-800 mb-12 text-center">
          <span className="font-bold">Nos solutions</span>
        </h2>

        <div className="grid md:grid-cols-3 gap-8 stagger-animation">
          {solutions.map((solution) => (
            <div 
              key={solution.id}
              className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 group hover-lift"
            >
              {/* Image */}
              <div className="relative h-56 overflow-hidden img-zoom">
                <ResponsiveImage sizes="(min-width: 1280px) 384px, (min-width: 768px) 33vw, 100vw"
                  src={solution.image}
                  alt={solution.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">
                  {solution.title}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {solution.description}
                </p>
                <a 
                  href={solution.link}
                  className="inline-flex items-center gap-2 text-[#E30022] font-medium hover:underline group/link"
                >
                  En savoir plus
                  <ArrowRight className="h-4 w-4 group-hover/link:translate-x-1 transition-transform" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
